import { motion } from "framer-motion";

const SidebarMobile = ({ menuStatus, links  }) => {
  return (
<>
      {menuStatus && (
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          exit={{ x: "-100%" }}
          transition={{ duration: 0.3 }}
          className="block md:hidden w-full h-full pt-3 bg-gray-800 text-white min-w[260px] px-3 shadow-lg z-10 sm:z-100 flex-col"
        >
          <div className="flex gap-4 pb-3 text-2xl">
            <span className="pt-1 overflow-ellipsis capitalize">
            </span>
          </div>
          <ul className=" pt-2 flex flex-col gap-3 w-full pr-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-transparent">
            {links}
          </ul>
        </motion.div>
      )}
      </>
  );
};

export default SidebarMobile;
